'use strict';

import { render } from 'react-dom';
import bootMobileNav from './mobile-nav.jsx';
import Menus from "./Menus.jsx";
import SearchPanel from './SearchPanel.jsx';
import tippy_defaults from './tippy-defaults.js';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import Tippy from '@tippy.js/react';

jQuery($ => {
	bootMobileNav($);
	
	const swiftype_engine = $('meta[name=swiftype-engine]').attr('content');
	
	// Boot main menu for frontend if it's present
	const target_element = document.getElementById('navbar--dynamic-menus');
	if (target_element) {
		render(
			<Menus
				menus={ $('.nav-dropdown') }
				admin_content={ $('#navbar--admin-content').html() }
				article_key={ $('meta[name=internachi-article]').attr('content') }
				csrf={ 'csrfToken' in window ? window.csrfToken : $('meta[name=csrf-token]').attr('content') }
				swiftype_engine={ swiftype_engine }
				current_url={ window.location.href }
			/>,
			target_element,
			() => {
				$('#navbar--static-menus').attr('class', 'hidden');
			}
		);
	} else {
		// Otherwise, try search-only menu for dashboard
		const search_element = document.getElementById('navbar--search-menu');
		if (search_element) {
			render(
				<Tippy
					{ ...tippy_defaults }
					trigger="click"
					appendTo={ document.body }
					delay={ null }
					content={ <SearchPanel loading={ false } engine={ swiftype_engine } /> }
				>
					<span className="py-2 mx-2 text-base text-white no-underline cursor-pointer font-condensed">
						<Icon icon={ faSearch } className="w-6 h-6" />
					</span>
				</Tippy>,
				search_element
			);
		}
	}
});
